import type { IPaginationProps } from "@fetcher/models/IPagination";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Space, Stack } from "@mantine/core";
import LoLFAQ from "@modules/lol/faq/LoLFAQ";
import { useSmurfsRankedFilters } from "@modules/ranked/hooks/useSmurfsRankedFilters";
import SEO from "../../seo/SEO";
import NeedHelpBanner from "../../shared/help-banner/NeedHelpBanner";
import ReviewCarousel from "../../shared/reviews/ReviewCarousel";
import reviews from "../../shared/reviews/defaultReviews";
import { RankedAdvantages } from "../components/RankedAdvantages";
import { RankedExplanations } from "../components/RankedExplanations";
import { SmurfRankedList } from "../components/SmurfRankedList";
import { SmurfsRankedFeatures } from "../components/SmurfsRankedFeatures";
import { SmurfsRankedFilterSection } from "../components/SmurfsRankedFilterSection";
import { SmurfsRankedHero } from "../components/SmurfsRankedHero";
import { SmurfsRankedInfo } from "../components/SmurfsRankedInfo";

const SmurfsRankedPage: React.FC = () => {
  const { t } = useAppTranslation("pages.ranked");
  const { t: commonT } = useAppTranslation("common.regions");

  const { rankedAccounts, filters, setters, handlers, skinsList } =
    useSmurfsRankedFilters();
  const { currentRegion } = useAppRegion();

  return (
    <div>
      <SEO
        title={t("seo.title", { region: currentRegion.toUpperCase() })}
        description={t("seo.description", {
          regionName: commonT(currentRegion),
          regionCode: currentRegion.toUpperCase(),
        })}
      />
      <SmurfsRankedHero />
      <Stack align="center" className="w-full bg-primary-background">
        <SmurfsRankedFilterSection
          region={currentRegion}
          handleRegionChange={handlers.handleRegionChange}
          filters={filters}
          setters={setters}
          skinsList={skinsList}
        />

        <SmurfRankedList
          onPaginate={handlers.onPaginate}
          paginationProps={
            { ...rankedAccounts?.meta, currentPage: filters.page } as
              | IPaginationProps
              | undefined
          }
          accounts={rankedAccounts?.data}
        />

        <SmurfsRankedInfo />

        <SmurfsRankedFeatures />

        <LoLFAQ />

        <RankedAdvantages />

        <NeedHelpBanner />
        <Space h="lg" />
        <ReviewCarousel reviews={reviews} />

        <RankedExplanations />
      </Stack>
    </div>
  );
};

export default SmurfsRankedPage;
